module.exports = __webpack_public_path__ + "media/images/fanclub/kv-chara-02@3x-ecef386973571fcb7297401d9e581cda.png";